<div class="container inflate">
    <div class="diagram inflate" [chart]="chart"></div>
    <div class="callout-container">
        <div class="callout" [style.opacity]="calloutHidden ? 0 : 1">
            <ng-container [ngSwitch]="isDetail">
                <ng-container *ngSwitchCase="true">
                    <div class="appliance-label-detail font-bold">
                        {{currentCallout.label}}
                    </div>
                    <span class="divider"></span>
                    <div class="appliance-usage-detail font-regular">
                        {{currentCallout.value}}
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                    <div class="appliance-icon"
                         [style.-webkit-mask-image]="currentCallout.image"
                         [style.mask-image]="currentCallout.image"
                         [style.background-color]="currentCallout.color">
                    </div>
                    <div class="appliance-category font-bold"
                         [style.color]="currentCallout.color">
                        {{currentCallout.label}}
                    </div>
                    <div class="appliance-usage font-regular">
                        {{currentCallout.value}}
                    </div>
                    <span *ngIf="currentCallout.applianceProfileComplete"
                          class="profile-incomplete-indicator"></span>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
